export const getPaginationRange = (page: number, size: number) => {
  const from = (page - 1) * size;
  const to = page * size - 1;

  return { from, to };
};
